export function formatCurrency(value) {  
    if (value % 1 === 0) {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minumumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(value);
    }
  
   return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 2,
    }).format(value);
}

export function convertSKUToSlug(sku) {  
    const skuSlugRegex = new RegExp(/[\/,\s]/, 'g')
    return sku.replace(skuSlugRegex, '-')
}